import React from "react";
import { useTranslation } from "react-i18next";
import { GoogleOutlined, FacebookFilled } from "@ant-design/icons";
import useErrors from "hooks/useErrors";
import ErrorAlerting from "common/error_alerting";
import firebase from "utils/firebase";
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  FacebookAuthProvider,
  getIdToken,
} from "firebase/auth";
// graphql

// styling
import { TextDivider, SocialButton, SocialMediaContainer } from "./SignUpStyle";

type AuthProvider = "google" | "facebook";

type SocialLoginProps = {
  type: "login" | "signup";
  loading: {
    google: boolean;
    facebook: boolean;
  };
  handleOauthLogin: (token: string, provider: AuthProvider) => void;
};

const SocialLogin = ({ type, loading, handleOauthLogin }: SocialLoginProps) => {
  const { t } = useTranslation("new_sign_up");
  const { errors, handleError, closeError } = useErrors();
  const auth = getAuth(firebase);
  const providers: { [key in AuthProvider]: any } = {
    google: new GoogleAuthProvider(),
    facebook: new FacebookAuthProvider(),
  };

  const loginWithOauth = async (provider: AuthProvider) => {
    try {
      const result = await signInWithPopup(auth, providers[provider]);
      const user = result?.user;
      if (user) {
        const token = await getIdToken(user);
        handleOauthLogin(token, provider);
      }
    } catch (error: any) {
      const errorMessage = error?.message;
      handleError({
        message: `${provider} sign-in error ${errorMessage}`,
      });
    }
  };

  return (
    <>
      {errors && (
        <div>
          <br />
          <ErrorAlerting errors={errors} onClose={closeError} />
        </div>
      )}
      <SocialMediaContainer>
        {process.env.REACT_APP_ENV === "production" ? null : (
          <SocialButton
            onClick={() => loginWithOauth("facebook")}
            aria-disabled={loading.facebook}
          >
            <div className="icon">
              <FacebookFilled />
            </div>
            {type === "signup"
              ? t("SIGN UP WITH FACEBOOK")
              : t("LOGIN WITH FACEBOOK")}
          </SocialButton>
        )}
        <SocialButton
          onClick={() => loginWithOauth("google")}
          aria-disabled={loading.google}
        >
          <div className="icon">
            <GoogleOutlined />
          </div>
          {type === "signup"
            ? t("SIGN UP WITH GOOGLE")
            : t("LOGIN WITH GOOGLE")}
        </SocialButton>
      </SocialMediaContainer>

      <TextDivider>{t("OR")}</TextDivider>
    </>
  );
};

export default SocialLogin;
